// HelmetWrapper.tsx
import React, { PropsWithChildren } from "react";
import { HelmetProvider } from "react-helmet-async";

const helmetContext = {};

const HelmetWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return <HelmetProvider context={helmetContext}>{children}</HelmetProvider>;
};

export default HelmetWrapper;